import React from 'react';
import { Compass, Expand, LocateFixed, Ruler, Globe, Pencil, ClockFading } from 'lucide-react';
import useGeoData from '../../../store/useGeoData'; // Importa lo store

interface WidgetMenuProps {
}

const WidgetMenu: React.FC<WidgetMenuProps> = () => {
  // Recupera stati e azioni necessari dallo store Zustand
  const isFullscreenControlActive = useGeoData(state => state.isFullscreenControlActive);
  const isGeolocateControlActive = useGeoData(state => state.isGeolocateControlActive);
  const isNavigationControlActive = useGeoData(state => state.isNavigationControlActive);
  const toggleFullscreenControl = useGeoData(state => state.toggleFullscreenControl);
  const toggleGeolocateControl = useGeoData(state => state.toggleGeolocateControl);
  const toggleNavigationControl = useGeoData(state => state.toggleNavigationControl);
  const isScaleControlActive = useGeoData(state => state.isScaleControlActive);
  const toggleScaleControl = useGeoData(state => state.toggleScaleControl);
  const isGlobeControlActive = useGeoData(state => state.isGlobeControlActive);
  const toggleGlobeControl = useGeoData(state => state.toggleGlobeControl);
  const isDrawWidgetActive = useGeoData(state => state.isDrawWidgetActive); // Stato per il widget di disegno
  const toggleDrawWidget = useGeoData(state => state.toggleDrawWidget); // Azione per il widget di disegno
  const isTimeWidgetActive = useGeoData(state => state.isTimeWidgetActive);
  const toggleTimeWidget = useGeoData(state => state.toggleTimeWidget);

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      alignItems: 'center',
      justifyItems: 'center',
      gap: 'var(--spacing-ml)',
      paddingLeft: 'var(--spacing-medium)',
      paddingRight: 'var(--spacing-medium)',
      paddingTop: 'var(--spacing-s)', // Mantenuto per spaziatura interna
      width: '100%',
      boxSizing: 'border-box',
    }}>
      <span title="Navigation Ctrl">
        <Compass
          size={20}
          onClick={toggleNavigationControl}
          className={isNavigationControlActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      <span title="Fullscreen Ctrl">
        <Expand
          size={20}
          onClick={toggleFullscreenControl}
          className={isFullscreenControlActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      <span title="Geolocate Ctrl">
        <LocateFixed
          size={20}
          onClick={toggleGeolocateControl}
          className={isGeolocateControlActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      {/* Rimosso Widget Terreno */}
      <span title="Scale Ctrl">
        <Ruler
          size={20}
          onClick={toggleScaleControl}
          className={isScaleControlActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      <span title="Globe Ctrl">
        <Globe
          size={20}
          onClick={toggleGlobeControl}
          className={isGlobeControlActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      <span title="Draw Ctrl">
        <Pencil
          size={20}
          onClick={toggleDrawWidget}
          className={isDrawWidgetActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
      <span title="TimeFilter Ctrl">
        <ClockFading
          size={20}
          onClick={toggleTimeWidget}
          className={isTimeWidgetActive ? 'active-widget-icon' : ''}
          style={{ cursor: 'pointer', transition: 'color 0.2s, background-color 0.2s' }}
        />
      </span>
    </div>
  );
};

export default WidgetMenu;